import React from 'react';
import { Routes, Route } from 'react-router-dom';
import Layout from './components/Layout/Layout';
import Home from './Home/Home';
import Admin from './Admin/Admin';
import CourseDetails from './Pages/Courses_details/Courses_Details';
import About from './Pages/About/About';
import Contact from './Pages/Contct/Contact';
import Courseslist from './Pages/CoursesList/CoursesList';
import Programs from './Pages/Programs/Programs';
import DiplomaDetails from './Pages/Diplomadetails/DiplomaDetails';
import EnrollPage from './Pages/Enroll/EnrollPage';
import BlogDetails from './Pages/BlogDetails/BlogDetails'
import Blog from './Pages/Blog/Blog'
import NotFound from './Pages/NotFound/NotFound'; // Add a NotFound page
import Library from './Pages/Library/Library';

function App() {
  return (
    <Routes>
      <Route path="/admin" element={<Admin />} />
      <Route element={<Layout />}>
        <Route path="/" element={<Home />} />
        <Route path="/course-details/:id" element={<CourseDetails />} />
        <Route path="/about" element={<About />} />
        <Route path="/contact" element={<Contact />} />
        <Route path="/Courseslist" element={<Courseslist />} />
        <Route path="/Programs" element={<Programs />} />
        <Route path="/Library" element={<Library />} />
        <Route path="/blog" element={<Blog />} />
        <Route path="/diploma-details/:diplomaId" element={<DiplomaDetails />} />
        <Route path="/blog/:id" element={<BlogDetails />} />
        <Route path="/enroll/:type/:id" element={<EnrollPage />} />
        <Route path="*" element={<NotFound />} />
      </Route>
    </Routes>
  );
}

export default App;
